import type { FunctionComponent } from 'react';

import styled from 'styled-components';
import {
  boxShadow,
  mediaHelper,
  paletteHelper,
  spacingHelper,
  Stack,
} from '@property.com.au/ui-kit';
import { SchoolTitleWithData } from './subcomponents/SchoolTitle/SchoolTitleWithData';
import { SchoolPageBreadCrumbsWithData } from './subcomponents/SchoolPageBreadCrumbs/SchoolPageBreadCrumbs';
import { PageContainer } from '../../../app-kit/components/PageContainer/PageContainer';
import { SchoolOutboundLinksWithData } from './subcomponents/SchoolOutboundLink/SchoolOutboundLinksWithData';
import { SchoolPageTabsWithData } from './subcomponents/SchoolPageTabs/SchoolPageTabsWithData';

export const PageHeaderContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border-bottom: 1px solid ${paletteHelper('borderPrimary')};
  padding-bottom: 0;
  ${boxShadow.headerBoxShadow}
`;

export const PageHeaderInnerContainer = styled(PageContainer)`
  padding: ${spacingHelper('4rem large 0')};

  ${mediaHelper('desktopMin')} {
    padding-left: 0;
    padding-right: 0;
  }
`;

const SchoolLinkAndTabsContainer = styled(Stack)`
  margin-top: ${spacingHelper('large')};
`;

export const SchoolContentHeader: FunctionComponent = () => {
  return (
    <PageHeaderContainer>
      <SchoolPageBreadCrumbsWithData />
      <PageHeaderInnerContainer>
        <SchoolTitleWithData />
        <SchoolLinkAndTabsContainer gap="large">
          <SchoolOutboundLinksWithData />
          <SchoolPageTabsWithData />
        </SchoolLinkAndTabsContainer>
      </PageHeaderInnerContainer>
    </PageHeaderContainer>
  );
};
